import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@bit/daviidli.corn-ui.button';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { numStringToCss, prop } from '@bit/daviidli.corn-ui.utils';
import SideBarPanel from './SideBarPanel';
const DarkOverlay = styled.div `
	transition: opacity 0.75s ease 0.25s, ${p => (p.Open ? 'z-index 1ms linear' : 'z-index 1ms linear 1s')};
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.45);
	opacity: ${p => (p.Open ? '1' : '0')};
	z-index: ${p => (p.Open ? '0' : '-1')};
	overflow: hidden;
`;
const SideBarButton = styled.div `
	position: fixed;
	top: ${prop('Top')};
	left: ${prop('Left')};
`;
const SideBar = (props) => {
    const { open, onOpen, onClose, children, top, left, showOverlay, className, openButton, closeButton } = props;
    const [buttonDimensions, setButtonDimensions] = useState(0);
    const buttonRef = useRef(null);
    useEffect(() => {
        if (buttonRef && buttonRef.current) {
            setButtonDimensions(buttonRef.current.offsetHeight);
        }
    }, [buttonRef, setButtonDimensions]);
    const topStr = numStringToCss(top);
    const leftStr = numStringToCss(left);
    if (open) {
        document.body.style.overflow = 'hidden';
    }
    else {
        document.body.style.overflow = 'unset';
    }
    const onButtonClick = () => {
        if (open) {
            onClose();
        }
        else {
            onOpen();
        }
    };
    const sideBarPanelProps = Object.assign(Object.assign({}, props), { top: topStr, left: leftStr, open,
        buttonDimensions });
    return ReactDOM.createPortal(React.createElement("div", { className: `corn-sidebar${className ? ` ${className}` : ''}` },
        showOverlay ? (React.createElement(DarkOverlay, { className: "corn-sidebar-overlay", Open: open })) : null,
        React.createElement(SideBarPanel, Object.assign({}, sideBarPanelProps), children),
        React.createElement(SideBarButton, { onClick: onButtonClick, Top: topStr, Left: leftStr, ref: buttonRef }, !open ? openButton : closeButton)), document.body);
};
const defaultOpenButton = (React.createElement(Button, { corners: "circle" },
    React.createElement(AiOutlineMenu, null)));
const defaultCloseButton = (React.createElement(Button, { corners: "circle" },
    React.createElement(AiOutlineClose, null)));
SideBar.propTypes = {
    open: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]),
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    panelColor: PropTypes.string,
    showOverlay: PropTypes.bool,
    className: PropTypes.string,
    openButton: PropTypes.node,
    closeButton: PropTypes.node
};
SideBar.defaultProps = {
    top: '1rem',
    left: '1rem',
    size: 'md',
    width: 300,
    panelColor: '#aaa',
    showOverlay: false,
    openButton: defaultOpenButton,
    closeButton: defaultCloseButton
};
export default SideBar;
